/** The subject colour keys offered on desktop and phone; a subject's colour is its small identity square. */
export const SUBJECT_COLORS = [
  '#6366f1', '#8b5cf6', '#ec4899', '#ef4444',
  '#f97316', '#eab308', '#22c55e', '#10b981',
  '#06b6d4', '#3b82f6', '#64748b', '#78716c',
];
